const footerLinks = [
  { label: "首页", href: "#top" },
  { label: "可用入口", href: "#addresses" },
  { label: "新域名公告", href: "#domain" },
  { label: "使用指南", href: "#guide" },
  { label: "常见问题", href: "#faq" },
  { label: "关于本站", href: "#about" },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-secondary-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-base font-bold text-background-50">
                本
              </span>
              <span className="font-heading text-lg text-secondary-50">本子站导航</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-6 text-secondary-200">
              长期维护的镜像导航页，汇总备用地址与新域名，为原站留一条不断更的路。
            </p>
            <div className="mt-5 flex items-center gap-2 text-sm text-secondary-200">
              <i className="ri-mail-line" />
              <a href="mailto:contact@benzi-nav.example" rel="nofollow" className="hover:text-secondary-50">
                contact@benzi-nav.example
              </a>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-secondary-50">快速导航</h4>
            <ul className="mt-4 grid grid-cols-2 gap-2">
              {footerLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-secondary-200 transition hover:text-secondary-50">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-secondary-50">使用提示</h4>
            <p className="mt-4 text-sm leading-6 text-secondary-200">
              建议将此页加入书签（Ctrl+D）。当原站无法访问时，打开书签即可直达最新可用入口。
            </p>
          </div>
        </div>
        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-secondary-700 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-secondary-300">
            本站仅提供入口导航与镜像地址汇总，不存储或传播任何内容。
          </p>
          <p className="text-xs text-secondary-300">© 2026 本子站导航 · 保持更新，伴你不断更</p>
        </div>
      </div>
    </footer>
  );
}